$( document ).ready(function() {
      $('.golden').slick({
      infinite: true,
      speed: 2000, // Speed of the transition animation
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<button type="button" class="prev slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10 17.63L2.185 9.815L10 2" stroke="#C8A564" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="next slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M2 17.63L9.815 9.815L2 2" stroke="#C8A564" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      pauseOnHover:true,
      responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
           arrows: false,
           autoplay: true,
          autoplaySpeed: 1000
        }
      }
    ]
  });
});
 